import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "~/providers/LanguageProvider";
import { useFiltersStore } from "~/stores/filters/useFilterStore";
import { FilterOption } from "~/types/filters.types";
import { LabelTranslation } from "~/types";

const useIndustryFilters = () => {
    const { language } = useContext(LanguageContext);
    const industries = useFiltersStore(state => state.industryFilters);
    const isLoading = useFiltersStore(state => state.isLoadingIndustryFilters);

    const [filteredIndustries, setFilteredIndustries] = useState<FilterOption[]>(industries);
    const [search, setSearch] = useState<string>("");

    const checkKeywordMatch = (label: string, keyword: string) =>
        label.toLowerCase().includes(keyword.trim().toLowerCase());

    useEffect(() => {
        let result = [...industries];

        if (search) {
            result = industries.filter(company =>
                checkKeywordMatch((company.label as LabelTranslation)[language], search)
            );
        }
        setFilteredIndustries(result);
    }, [industries, search]);

    return {
        industries: filteredIndustries,
        isLoading,
        search,
        setSearch
    };
};

export default useIndustryFilters;
